var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestimonial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 81,
    viewBox: "0 0 92 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2554 6.33847V35.1618C55.2554 38.6646 57.8238 41.5004 60.9968 41.5004H72.0112V43.6355L64.5474 79.3487C64.3132 80.166 64.8646 81 65.6428 81H75.2218C75.6826 81 76.1056 80.6914 76.2794 80.216L92.0002 43.636V6.33857C92.0002 2.83579 89.4317 0 86.2587 0H60.9976C57.8248 0 55.2554 2.83547 55.2554 6.33847Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.586426 6.33847V35.1618C0.586426 38.6646 3.09224 41.5004 6.18787 41.5004H16.9336V43.6355L9.65179 79.3487C9.42332 80.166 9.96133 81 10.7205 81H20.0658C20.5154 81 20.9281 80.6914 21.0977 80.216L36.435 43.636V6.33857C36.435 2.83579 33.9292 0 30.8336 0H6.1886C3.09317 0 0.586426 2.83547 0.586426 6.33847Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonial);
export default __webpack_public_path__ + "static/media/Testimonial.b28f0d2adc24112177ef93a0ed5ba24e.svg";
export { ForwardRef as ReactComponent };